export default __webpack_public_path__ + "static/img-mesquita-1-98fade86aecb070db783f9548d65bb76.png";